import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Skeleton } from "@mui/material";
import { useDispatch } from "react-redux";
import { createStyles, makeStyles } from "@mui/styles";
import Base from "../../../Base/views/Base";
import { useSelector } from 'react-redux';
import SubscribeButton from "../../../Base/views/SubscribeButton";
import GradientText from "../../../Base/views/GradientText";
import ChoosePlanPopup from "./ChoosePlanPopup";
import Popup from "../../../Base/views/Popup";
import { GetSubscriptionAction } from '../../../../../store/Ancillary/Subscribe/Action';
import { getUserData } from "../../../Base/helper/baseFunctions";

const SubscribeSettingsLandingPage = () => {
    const dispatch = useDispatch();
    var data = getUserData();
    const [openPopup, setOpenPopup] = useState(false);
    const { subscriptionData, isLoading } = useSelector(state => state?.AncillaryReducer?.SubscriptionReducer);
    const useStyles = makeStyles((theme) =>
        createStyles({
            Paper: {
                boxShadow: "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
                padding: "20px",
                borderRadius: "10px",
                backgroundColor: "#f3edfd",
            },

        })
    );
    const classes = useStyles();

    useEffect(() => {
        dispatch(GetSubscriptionAction());
    }, []);

    return (
        <Base>
            <Paper
                className={classes.Paper}
                sx={{
                    borderRadius: "10px",
                    minHeight: "87vh",
                    maxHeight: "87vh",
                    overflowY: "auto",
                    padding: "20px",
                }}
            >
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" fontWeight="bold">
                        Manage Subscription
                    </Typography>
                </Box>
                <Paper elevation={2} sx={{ p: 3, mb: 2, borderRadius: "10px" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography variant="subtitle1">
                            Your Plan
                        </Typography>
                        {
                            ["owner", "Owner"].includes(data?.user_type) && (
                                <SubscribeButton text={"Change Plan"} onClick={() => setOpenPopup(true)} />
                            )}
                    </Box>
                    {isLoading ? (
                        <>
                            <Skeleton variant="text" width={150} height={28} sx={{ mt: 1 }} />
                            <Skeleton variant="text" width={200} height={22} sx={{ mt: 1 }} />
                            <Box sx={{ mt: 2, mb: 1 }}>
                                <Skeleton variant="text" width={120} height={22} />
                            </Box>
                        </>
                    ) : (
                        <>
                            <GradientText>{subscriptionData?.plan_name} Trial</GradientText>
                            <Typography variant="body2" sx={{ color: "#8a93a2" }}>
                                Next payment on {new Date(subscriptionData?.due_date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                            </Typography>
                            <Box sx={{ mt: 2, mb: 1 }}>
                                <Typography variant="body2">
                                    <span style={{ fontWeight: 600 }}>{subscriptionData?.expiry_days}</span> Days Remaining
                                </Typography>
                            </Box>
                        </>
                    )}
                </Paper>
                {/* Cancel Subscription Section */}
                {/* <Paper elevation={2} sx={{ p: 3, borderRadius: "10px" }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        End Subscription
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Upon cancelling, you will lose access to customer data in Boardme.
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                        <Button onClick={() => {
                            setOpenPopup(true);
                        }} variant="contained" color="error" sx={{ color: "white" }}>
                            Cancel your subscription
                        </Button>
                    </Box>
                </Paper> */}
            </Paper>
            <Popup
                title={"Change Plan"}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >
                <ChoosePlanPopup subscriptionData={subscriptionData} setOpenPopup={setOpenPopup} />
            </Popup>
        </Base>
    );
};

export default SubscribeSettingsLandingPage;